import * as React from 'react';
import RssFeedCmp from './RssFeedCmp';
import RssItemsCmp from '../rss-items/RssItemsCmp';
import BreadCrumbCmp from '../../components/common/BreadCrumbCmp';
import { useEffect } from 'react';
import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import { useFeed } from '../../hooks/useQueries';
import { useAppContext } from '../../providers/AppContext';

export default function RssFeedPage() {
  const { feedId } = useParams();
  const { setPageTitle } = useAppContext();

  const { data: result } = useFeed(Number(feedId));

  useEffect(() => {
    if (result?.result?.feed) {
      setPageTitle(result.result.feed.title);
      document.title = 'Gazete Bayii - ' + result.result.feed.title;
    }
  }, [result, setPageTitle]);

  const feedData = result?.result;

  return (
    <Container>
      {feedData ? (
        <>
          <BreadCrumbCmp items={feedData.breadcrumbContainer?.items || []} />
          {feedData.feed && <RssFeedCmp feed={feedData.feed} />}
          <RssItemsCmp items={feedData.itemList} />
        </>
      ) : null}
    </Container>
  );
}
